import { ReactComponent as POSIcon } from "../../images/POS.svg";
import { ReactComponent as TicketingIcon } from "../../images/Ticketing.svg";
import { ReactComponent as CashlessIcon } from "../../images/Cashless.svg";
import { ReactComponent as StockIcon } from "../../images/Stock.svg";
import { ReactComponent as TablePlanIcon } from "../../images/Tables.svg";
import { ReactComponent as BudgetIcon } from "../../images/Cash.svg";
import { ReactComponent as AccreditationsIcon } from "../../images/Accreditations.svg";
import { ReactComponent as NotesIcon } from "../../images/Meeting.svg";
import { ReactComponent as TakeawayIcon } from "../../images/Webshop.svg";
import { ReactComponent as BartrackIcon } from "../../images/BarTrack.svg";

export const DASHBOARD_APP_VERSION = 1;

export const DASHBOARD_APP_IDS = {
  POS: "pos",
  TICKETING: "ticketing",
  CASHLESS: "cashless",
  STOCK: "stock",
  TABLE_PLAN: "tablePlan",
  BUDGET: "budget",
  ACCREDITATIONS: "accreditations",
  NOTES: "notes",
  TAKEAWAY: "takeaway",
  BARTRACK: "bartrack",
};

export const DASHBOARD_APP_CATALOG = [
  {
    id: DASHBOARD_APP_IDS.POS,
    labelKey: "apps.pos.title",
    descriptionKey: "apps.pos.description",
    routes: ["/dashboard/pos", "/dashboard/overview", "/dashboard/history"],
    Icon: POSIcon,
    gradient: "linear-gradient(135deg, #233e84 0%, #50308d 54%, #8a2a83 100%)",
  },
  {
    id: DASHBOARD_APP_IDS.TICKETING,
    labelKey: "apps.ticketing.title",
    descriptionKey: "apps.ticketing.description",
    routes: ["/dashboard/ticketing"],
    Icon: TicketingIcon,
    gradient: "linear-gradient(135deg, #1e3a8a 0%, #4c2a90 54%, #922f88 100%)",
  },
  {
    id: DASHBOARD_APP_IDS.CASHLESS,
    labelKey: "apps.cashless.title",
    descriptionKey: "apps.cashless.description",
    routes: ["/dashboard/cashless-cards"],
    Icon: CashlessIcon,
    gradient: "linear-gradient(135deg, #164e63 0%, #21438f 52%, #5b2f91 100%)",
  },
  {
    id: DASHBOARD_APP_IDS.STOCK,
    labelKey: "apps.stock.title",
    descriptionKey: "apps.stock.description",
    routes: ["/dashboard/stock-management"],
    Icon: StockIcon,
    gradient: "linear-gradient(135deg, #14532d 0%, #155e75 48%, #4338ca 100%)",
  },
  {
    id: DASHBOARD_APP_IDS.TABLE_PLAN,
    labelKey: "apps.tablePlan.title",
    descriptionKey: "apps.tablePlan.description",
    routes: ["/dashboard/table-plan"],
    Icon: TablePlanIcon,
    gradient: "linear-gradient(135deg, #4a2c7d 0%, #7f2f85 50%, #a83280 100%)",
  },
  {
    id: DASHBOARD_APP_IDS.BUDGET,
    labelKey: "apps.budget.title",
    descriptionKey: "apps.budget.description",
    routes: ["/dashboard/budget"],
    Icon: BudgetIcon,
    gradient: "linear-gradient(135deg, #123e6b 0%, #314197 52%, #70308d 100%)",
  },
  {
    id: DASHBOARD_APP_IDS.ACCREDITATIONS,
    labelKey: "apps.accreditations.title",
    descriptionKey: "apps.accreditations.description",
    routes: ["/dashboard/accreditations"],
    Icon: AccreditationsIcon,
    gradient: "linear-gradient(135deg, #25306f 0%, #70308d 50%, #aa2e86 100%)",
  },
  {
    id: DASHBOARD_APP_IDS.NOTES,
    labelKey: "apps.notes.title",
    descriptionKey: "apps.notes.description",
    routes: ["/dashboard/notes"],
    Icon: NotesIcon,
    gradient: "linear-gradient(135deg, #164e63 0%, #3b3a94 48%, #75308d 100%)",
  },
  {
    id: DASHBOARD_APP_IDS.TAKEAWAY,
    labelKey: "apps.takeaway.title",
    descriptionKey: "apps.takeaway.description",
    routes: ["/dashboard/takeaway-overview"],
    Icon: TakeawayIcon,
    gradient: "linear-gradient(135deg, #5f3272 0%, #933281 52%, #c13a96 100%)",
  },
  {
    id: DASHBOARD_APP_IDS.BARTRACK,
    labelKey: "apps.bartrack.title",
    descriptionKey: "apps.bartrack.description",
    routes: ["/dashboard/bartrack-overview"],
    Icon: BartrackIcon,
    gradient: "linear-gradient(135deg, #53346f 0%, #843280 50%, #b1338a 100%)",
  },
];

export const DASHBOARD_APP_PROFILES = [
  {
    id: "club",
    labelKey: "profiles.club.title",
    appIds: [
      DASHBOARD_APP_IDS.POS,
      DASHBOARD_APP_IDS.TICKETING,
      DASHBOARD_APP_IDS.CASHLESS,
      DASHBOARD_APP_IDS.STOCK,
      DASHBOARD_APP_IDS.BUDGET,
      DASHBOARD_APP_IDS.ACCREDITATIONS,
      DASHBOARD_APP_IDS.NOTES,
    ],
  },
  {
    id: "bar_restaurant",
    labelKey: "profiles.barRestaurant.title",
    appIds: [
      DASHBOARD_APP_IDS.POS,
      DASHBOARD_APP_IDS.CASHLESS,
      DASHBOARD_APP_IDS.TABLE_PLAN,
      DASHBOARD_APP_IDS.STOCK,
      DASHBOARD_APP_IDS.TAKEAWAY,
    ],
  },
  {
    id: "event",
    labelKey: "profiles.event.title",
    appIds: [
      DASHBOARD_APP_IDS.POS,
      DASHBOARD_APP_IDS.TICKETING,
      DASHBOARD_APP_IDS.CASHLESS,
      DASHBOARD_APP_IDS.BUDGET,
      DASHBOARD_APP_IDS.ACCREDITATIONS,
      DASHBOARD_APP_IDS.NOTES,
    ],
  },
  {
    id: "ticketing",
    labelKey: "profiles.ticketing.title",
    appIds: [DASHBOARD_APP_IDS.TICKETING, DASHBOARD_APP_IDS.ACCREDITATIONS],
  },
  {
    id: "advanced",
    labelKey: "profiles.advanced.title",
    appIds: DASHBOARD_APP_CATALOG.map((app) => app.id),
  },
];

export const getAllDashboardAppIds = () => DASHBOARD_APP_CATALOG.map((app) => app.id);

export const normalizeDashboardAppIds = (appIds) => {
  const validIds = new Set(getAllDashboardAppIds());
  const normalized = Array.isArray(appIds)
    ? appIds.filter((appId) => validIds.has(appId))
    : [];

  return [...new Set(normalized)];
};

export const getSelectedDashboardAppIds = (dashboardApps) => {
  if (!dashboardApps?.preferencesConfirmedAt) {
    return getAllDashboardAppIds();
  }

  const selected = normalizeDashboardAppIds(dashboardApps.selectedAppIds);
  return selected.length > 0 ? selected : getAllDashboardAppIds();
};
